import { NgZone, Injectable } from '@angular/core';

import { AbstractEventPlugin } from './abstract.plugin';

@Injectable({
  providedIn: 'root',
})
export class ZonelessPlugin extends AbstractEventPlugin {
  public static ngZone?: NgZone;

  protected readonly modifier = '.zoneless';

  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  public override addEventListener(element: HTMLElement, eventName: string, handler: Function): Function {
    ZonelessPlugin.ngZone = this.manager.getZone();

    return ZonelessPlugin.ngZone.runOutsideAngular(() => {
      return this.manager.addEventListener(element, this.unwrap(eventName), handler);
    });
  }
}
